module.exports = __webpack_public_path__ + "static/img/8.6b9e7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/my/0/8.png
// module id = F5b7
// module chunks = 1